import React from 'react'

const title = Object.assign({fontFamily: 'Oswald'}, {color: '#ab5b5b'}, {fontWeight: 'bold'})
const paragraph = Object.assign({fontSize: '16px'}, {textAlign: 'justify'})

class About extends React.Component {
  render () {
    return (
      <div className="row">
        <div className="col-md-10 col-md-offset-1">
          <div id="content" style={{padding: '25px'}}>
          <h1 style={title}>How to Evaluate Draft Pick/Keeper Trades</h1>
          <br/>

          <p style={paragraph}>Pretend you're in an auction league -- think
            of how much of an advantage would it be to start with $250 when
            everyone else has $200. On average, you'd likely be the favorite
            heading into the season, no?</p>
         
          <p style={paragraph}>Or consider a head-to-head match up between
            two teams, one with a starting line up of players who go (on
            average) for $137, the other $97. You'd expect the team with more
            value would win more often, right?</p>
            
          <p style={paragraph}>In a nutshell, this is how the Keeper Trade
            Calculator works.  Basically: estimating the value of draft picks
            is easy, all you need to do is think about the value of the
            player you'll be able to pick there. Estimating the value of
            players is easy too, we have the perfect metric in Average
            Auction Values (AAV).</p>

          <p style={paragraph}>Why is it perfect?  An established body of
            literature has shown the aggregated predictions of crowds or
            groups of experts consistently outperform any particular person
            or expert. It's why very few fund managers can consistently beat
            a simple index fund, and why the aggregated average of polls
            tends to do better predicting elections than any one
            pollster. AAVs are the equivalent for fantasy football players.
            They have everything we need (upside, injury risk, scarcity at
            position, etc) baked in.</p>

          <p style={paragraph}>If you value picks this way, and make trades
            that increase it, you'll effectively be starting off your season
            with a higher budget than anyone else.</p>
          
          <p style={paragraph}>But how do we actually translate AAV values to
            picks? On the surface it seems like we'd just want to sort AAV in
            descending order (e.g. Antonio Brown - $55, Julio Jones - $53,
            ...), slap those values on picks (1st OVR - $55, 2nd - $53, ...)
            and call it a day. This is close, but not exactly right.</p>
            
          <p style={paragraph}>Instead, we can rely on the fact that -- in
            every individual league -- SOME players will drop.  We don't know
            who these will be ahead of time, but -- as long as we commit to
            drafting value, whoever it is -- we can plan on it and value our
            picks accordingly.  The question is then, on average, what AAV
            can we expect at each pick? To figure this out, the calculator
            relies on results from more than 6000 auction and snake draft
            leagues to calculate what type of value we can expect on average at
            each pick.</p>

          <p style={paragraph}>Evaluating draft picks is great, but another
            benefit of thinking about picks in terms of AAV is that it makes
            evaluating draft pick for player trades easy.  The calculator will
            value draft picks based on who's available and who's being kept, so
            make sure you enter all your leagues keepers for best results.</p>

          <p style={paragraph}>In leagues that allow it, trading draft picks
            (and keepers) is one of the most effective ways to add value to
            your team. I hope this pick value table is a theoretically sound
            place to start.</p>
            </div>
          </div>
        </div>
    )
  }
};

export default About



// WEBPACK FOOTER //
// ./src/components/About.js